// NATIVE
import { useEffect, useState } from 'react';

// INSTALLED
import { useFormikContext } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { Alert, Button, Card, Divider, Grid, Typography } from '@mui/material';

// CUSTOM
import { uploadPdfStore } from 'store/uploaders';
import AutocompleteField from 'components/formFields/autocompleteField';
import { UploadButtonField } from 'components/formFields/uploadButtonField';
import { LinearProgressWithLabel } from 'components/LinearProgressWithLabel';
import { PreviewPdfButton } from 'components/PreviewPdfButton';
import InputField from 'components/formFields/InputField';
import { DetailsComponents } from 'components/DetailsComponents';
import { ModalViewPdf } from 'components/modals/viwerPdf/ModalViewPdf';

export const EditSeguridadSocial = (props: any) => {
  const dispatch = useDispatch();

  const formikProps: any = useFormikContext();

  const [percentage_upload_cc, setPercentageUploadCc] = useState(0);
  const [percentage_upload_cs, setPercentageUploadCs] = useState(0);
  const [percentage_upload_al, setPercentageUploadAl] = useState(0);

  const [urlCajaCompensacion, setUrlCajaCompensacion] = useState<any>(null);
  const [showCajaCompensacionDetail, setShowCajaCompensacionDetail] = useState(false);

  const [showCesantiasDetail, setShowCesantiasDetail] = useState(false);
  const [urlCesantiasDetail, setUrlCesantiasDetail] = useState<any>(null);

  const [showArlDetail, setShowArlDetail] = useState(false);
  const [urlArlDetail, setUrlArlDetail] = useState<any>(null);

  // REDUX
  const { eps_list, eps_list_select }: any = useSelector((state: any) => state.eps);
  const { family_compensation_list, family_compensation_list_select }: any = useSelector(
    (state: any) => state.cajaCompensacion
  );
  const { cesantias_list, cesantias_list_select }: any = useSelector(
    (state: any) => state.cesantias
  );
  const { pension_list, pension_list_select }: any = useSelector((state: any) => state.pension);

  const { employee } = useSelector((state: any) => state.employee);

  const {
    formField: {
      // DATOS CLIENTE
      e_eps,
      e_familyCompensation,
      e_fileCajaCompensacion,
      e_cesantias,
      e_fileCesantias,
      e_pension,
      e_fileArl,
    },
  } = props;

  useEffect(() => {
    if (employee && Object.keys(employee).length > 0) {
      setEmployeeData(employee);
    }
  }, [employee]);

  useEffect(() => {
    if (employee && employee.file_family_compensation_fund) {
      setUrlCajaCompensacion(employee.file_family_compensation_fund);
    }
  }, [employee]);

  useEffect(() => {
    if (employee && employee.file_savings) {
      setUrlCesantiasDetail(employee.file_savings);
    }
  }, [employee]);

  useEffect(() => {
    if (employee && employee.arl_name_saved) {
      setUrlArlDetail(employee.arl_name_saved);
    }
  }, [employee]);

  const setEmployeeData = (employee: any) => {
    if (formikProps.values.is_initialized_seguridad_social) return;
    formikProps.setFieldValue('is_initialized_seguridad_social', true);

    if (employee.eps && employee.eps.id) {
      formikProps.setFieldValue('e_eps', { label: employee.eps.name, value: employee.eps.id });
    }
    if (employee.familyCompensationFund && employee.familyCompensationFund.id) {
      formikProps.setFieldValue('e_familyCompensation', {
        label: employee.familyCompensationFund.name,
        value: employee.familyCompensationFund.id,
      });
    }
    if (employee.saving && employee.saving.id) {
      formikProps.setFieldValue('e_cesantias', {
        label: employee.saving.name,
        value: employee.saving.id,
      });
    }
    if (employee.retirement && employee.retirement.id) {
      formikProps.setFieldValue('e_pension', {
        label: employee.retirement.name,
        value: employee.retirement.id,
      });
    }

    if (employee.file_savings) {
      formikProps.setFieldValue('e_fileCesantias', employee.file_savings);
      formikProps.setFieldValue('e_cesantias_name_saved', employee.file_savings);
    }

    if (employee.arl_name_saved) {
      formikProps.setFieldValue('e_fileArl', employee.arl_name_saved);
      formikProps.setFieldValue('e_arl_name_saved', employee.arl_name_saved);
    }

    if (employee.file_family_compensation_fund) {
      formikProps.setFieldValue('e_fileCajaCompensacion', employee.file_family_compensation_fund);
      formikProps.setFieldValue(
        'e_caja_compensacion_name_saved',
        employee.file_family_compensation_fund
      );
    }
  };

  const uploadCajaCompensacion = async ({ target }: any) => {
    formikProps.setFieldValue('e_fileCajaCompensacion', target.files[0]);
    const { ok, data } = await dispatch(
      uploadPdfStore('caja-compensacion-empleado', target.files[0], setPercentageUploadCc)
    );

    if (ok) {
      formikProps.setFieldValue('e_caja_compensacion_name_saved_edited', data.pdfName);
      formikProps.setFieldValue('e_caja_compensacion_name_saved', data.pdfName);
    }
  };

  const uploadCesantias = async ({ target }: any) => {
    formikProps.setFieldValue('e_fileCesantias', target.files[0]);
    const { ok, data } = await dispatch(
      uploadPdfStore('cesantias-empleado', target.files[0], setPercentageUploadCs)
    );

    if (ok) {
      formikProps.setFieldValue('e_fileCesantias_edited', true);
      formikProps.setFieldValue('e_cesantias_name_saved', data.pdfName);
    }
  };

  const uploadArl = async ({ target }: any) => {
    formikProps.setFieldValue('e_fileArl', target.files[0]);
    const { ok, data } = await dispatch(
      uploadPdfStore('arl-empleado', target.files[0], setPercentageUploadAl)
    );

    if (ok) {
      formikProps.setFieldValue('e_arl_name_saved_edited', true);
      formikProps.setFieldValue('e_arl_name_saved', data.pdfName);
    }
  };

  const openCajaCompensacionDetail = () => {
    setShowCajaCompensacionDetail(!showCajaCompensacionDetail);
  };

  const openCajaCesantiasDetail = () => {
    setShowCesantiasDetail(!showCajaCompensacionDetail);
  };

  const openArlDetail = () => {
    setShowArlDetail(!showArlDetail);
  };

  return (
    <>
      {showCajaCompensacionDetail && (
        <ModalViewPdf
          open={showCajaCompensacionDetail}
          onClose={setShowCajaCompensacionDetail}
          pdfUrl={urlCajaCompensacion}
        />
      )}

      {showCesantiasDetail && (
        <ModalViewPdf
          open={showCesantiasDetail}
          onClose={setShowCesantiasDetail}
          pdfUrl={urlCesantiasDetail}
        />
      )}

      {showArlDetail && (
        <ModalViewPdf open={showArlDetail} onClose={setShowArlDetail} pdfUrl={urlArlDetail} />
      )}

      <Typography variant="h6" sx={{ fontWeight: 'bold', marginTop: 7, marginBottom: 4 }}>
        {' '}
        Información de Seguridad Social{' '}
      </Typography>

      <Grid container spacing={2}>
        <Grid size={{ xs: 3 }}>
          {eps_list_select && eps_list_select.length > 0 ? (
            <AutocompleteField
              options={eps_list_select}
              name={e_eps.name}
              label={e_eps.label}
              element={e_eps.name}
              required={true}
            />
          ) : (
            <InputField
              disabled
              error
              name={'N/A'}
              label={'Debes crear Las eps*'}
              variant="outlined"
              required={true}
              fullWidth
            />
          )}
        </Grid>

        <Grid size={{ xs: 3 }}></Grid>

        <Grid size={{ xs: 3 }}>
          {family_compensation_list_select && family_compensation_list_select.length > 0 ? (
            <AutocompleteField
              options={family_compensation_list_select}
              name={e_familyCompensation.name}
              label={e_familyCompensation.label}
              element={e_familyCompensation.name}
              required={true}
            />
          ) : (
            <InputField
              disabled
              error
              name={'N/A'}
              label={'Debes crear caja de compensacion*'}
              variant="outlined"
              fullWidth
            />
          )}
        </Grid>

        <Grid size={{ xs: 3 }}>
          <div onClick={openCajaCompensacionDetail}>
            <DetailsComponents />
          </div>
          <UploadButtonField
            accept={'application/pdf'}
            name={e_fileCajaCompensacion.name}
            label={e_fileCajaCompensacion.label}
            text={'Caja de compensacion'}
            required={
              !(
                formikProps.values.e_fileCajaCompensacion ||
                (formikProps.values.e_caja_compensacion_name_saved_edited &&
                  !formikProps.values.e_caja_compensacion_name_saved_edited.includes('dummy')) ||
                (formikProps.values.e_caja_compensacion_name_saved &&
                  !formikProps.values.e_caja_compensacion_name_saved.includes('dummy'))
              )
            }
            onChange={uploadCajaCompensacion}
            style={{ marginTop: 10, width: '100%' }}
          />

          {(formikProps.values.e_fileCajaCompensacion &&
            formikProps.values.e_caja_compensacion_name_saved_edited) ||
          formikProps.values.e_caja_compensacion_name_saved ? (
            <Card variant="elevation" sx={{ marginTop: 1.5, padding: 1, height: '70%' }}>
              <LinearProgressWithLabel
                percentage={
                  formikProps.values.e_caja_compensacion_name_saved ? 100 : percentage_upload_cc
                }
                label={formikProps.values.e_fileCajaCompensacion?.name || 'Caja de compensación'}
                hasIcon={true}
              />
              {!formikProps.values.e_caja_compensacion_name_saved?.includes('dummy') && (
                <PreviewPdfButton
                  fileName={formikProps.values.e_caja_compensacion_name_saved}
                  typeUrl="caja-compensacion-empleado"
                  onOpenPdf={props.onOpenPdf}
                />
              )}
            </Card>
          ) : (
            ''
          )}
        </Grid>
      </Grid>
      {/* END GRID  */}

      <Divider style={{ marginTop: 25 }} />
      <Typography variant="h6" sx={{ fontWeight: 'bold', marginTop: 7, marginBottom: 4 }}>
        {' '}
        Pensiones y Cesatias{' '}
      </Typography>

      <Grid container spacing={2}>
        <Grid size={{ xs: 3 }}>
          {cesantias_list_select && cesantias_list_select.length > 0 ? (
            <AutocompleteField
              options={cesantias_list_select}
              name={e_cesantias.name}
              label={e_cesantias.label}
              element={e_cesantias.name}
            />
          ) : (
            <InputField
              disabled
              error
              name={'N/A'}
              label={'Debes crear Las cesantias*'}
              variant="outlined"
              fullWidth
            />
          )}
        </Grid>

        <Grid size={{ xs: 3 }}>
          <div onClick={openCajaCesantiasDetail}>
            <DetailsComponents />
          </div>
          <UploadButtonField
            accept={'application/pdf'}
            name={e_fileCesantias.name}
            label={e_fileCesantias.label}
            text={'Cesantias'}
            required={
              !(
                formikProps.values.e_fileCesantias ||
                (formikProps.values.e_cesantias_name_saved_edited &&
                  !formikProps.values.e_cesantias_name_saved_edited.includes('dummy')) ||
                (formikProps.values.e_cesantias_name_saved &&
                  !formikProps.values.e_cesantias_name_saved.includes('dummy'))
              )
            }
            onChange={uploadCesantias}
            style={{ marginTop: 10, width: '100%' }}
          />
          {(formikProps.values.e_fileCesantias && formikProps.values.e_fileCesantias_edited) ||
          formikProps.values.e_cesantias_name_saved ? (
            <Card variant="elevation" sx={{ marginTop: 1.5, padding: 1, height: '70%' }}>
              <LinearProgressWithLabel
                percentage={formikProps.values.e_cesantias_name_saved ? 100 : percentage_upload_cs}
                label={formikProps.values.e_fileCesantias?.name || 'Cesantías'}
                hasIcon={true}
              />
              {!formikProps.values.e_cesantias_name_saved?.includes('dummy') && (
                <PreviewPdfButton
                  fileName={formikProps.values.e_cesantias_name_saved}
                  typeUrl="cesantias-empleado"
                  onOpenPdf={props.onOpenPdf}
                />
              )}
            </Card>
          ) : (
            ''
          )}
        </Grid>

        <Grid size={{ xs: 3 }}></Grid>

        <Grid size={{ xs: 3 }}>
          {cesantias_list_select && cesantias_list_select.length > 0 ? (
            <AutocompleteField
              options={pension_list_select}
              name={e_pension.name}
              label={e_pension.label}
              required={true}
              element={e_pension.name}
            />
          ) : (
            <InputField
              disabled
              error
              name={'N/A'}
              label={'Debes crear Las pensiones*'}
              variant="outlined"
              required={true}
              fullWidth
            />
          )}
        </Grid>
      </Grid>
      {/* END GRID  */}

      <Divider style={{ marginTop: 25 }} />
      <Typography variant="h6" sx={{ fontWeight: 'bold', marginTop: 7, marginBottom: 4 }}>
        {' '}
        Arl{' '}
      </Typography>

      <Grid container spacing={2}>
        <Grid size={{ xs: 3 }}>
          <div onClick={openArlDetail}>
            <DetailsComponents />
          </div>
          <UploadButtonField
            accept={'application/pdf'}
            name={e_fileArl.name}
            label={e_fileArl.label}
            text={'Arl'}
            required={
              !(
                formikProps.values.e_fileArl ||
                (formikProps.values.e_arl_name_saved_edited &&
                  !formikProps.values.e_arl_name_saved_edited.includes('dummy')) ||
                (formikProps.values.e_arl_name_saved &&
                  !formikProps.values.e_arl_name_saved.includes('dummy'))
              )
            }
            onChange={uploadArl}
            style={{ marginTop: 10, width: '100%' }}
          />
          {(formikProps.values.e_fileArl && formikProps.values.e_arl_name_saved_edited) ||
          formikProps.values.e_arl_name_saved ? (
            <Card variant="elevation" sx={{ marginTop: 1.5, padding: 1, height: '70%' }}>
              <LinearProgressWithLabel
                percentage={formikProps.values.e_arl_name_saved ? 100 : percentage_upload_al}
                label={formikProps.values.e_fileArl?.name || 'ARL'}
                hasIcon={true}
              />
              {!formikProps.values.e_arl_name_saved?.includes('dummy') && (
                <PreviewPdfButton
                  fileName={formikProps.values.e_arl_name_saved}
                  typeUrl="arl-empleado"
                  onOpenPdf={props.onOpenPdf}
                />
              )}
            </Card>
          ) : (
            ''
          )}
        </Grid>
      </Grid>
      {/* END GRID  */}
    </>
  );
};
